export const AMBASSADORS_GET_PAYOUT = 'AMBASSADORS_GET_PAYOUT'
export const AMBASSADORS_SET_PAYOUT = 'AMBASSADORS_SET_PAYOUT'
export const AMBASSADORS_SET_PAYOUT_PROCESSING = 'AMBASSADORS_SET_PAYOUT_PROCESSING'

export const AMBASSADORS_GET_DETAILS = 'AMBASSADORS_GET_DETAILS'
export const AMBASSADORS_GET_SIGNUPS = 'AMBASSADORS_GET_SIGNUPS'
export const AMBASSADORS_SET_DETAILS = 'AMBASSADORS_SET_DETAILS'
export const AMBASSADORS_SET_SIGNUPS = 'AMBASSADORS_SET_SIGNUPS'
export const AMBASSADORS_SET_DETAILS_PROCESSING = 'AMBASSADORS_SET_DETAILS_PROCESSING'
export const AMBASSADORS_SET_SIGNUPS_PROCESSING = 'AMBASSADORS_SET_SIGNUPS_PROCESSING'

export const AMBASSADORS_GET_CAMPAIGNS = 'AMBASSADORS_GET_CAMPAIGNS'
export const AMBASSADORS_SET_CAMPAIGNS = 'AMBASSADORS_SET_CAMPAIGNS'
export const AMBASSADORS_SET_CAMPAIGNS_PROCESSING = 'AMBASSADORS_SET_CAMPAIGNS_PROCESSING'

export const AMBASSADORS_GET_UPCOMING_CAMPAIGNS = 'AMBASSADORS_GET_UPCOMING_CAMPAIGNS'
export const AMBASSADORS_SET_UPCOMING_CAMPAIGNS = 'AMBASSADORS_SET_UPCOMING_CAMPAIGNS'
export const AMBASSADORS_SET_UPCOMING_CAMPAIGNS_PROCESSING = 'AMBASSADORS_SET_UPCOMING_CAMPAIGNS_PROCESSING'

export const AMBASSADORS_GET_CAMPAIGN_DETAILS = 'AMBASSADORS_GET_CAMPAIGN_DETAILS'
export const AMBASSADORS_SET_CAMPAIGN_DETAILS = 'AMBASSADORS_SET_CAMPAIGN_DETAILS'
export const AMBASSADORS_SET_CAMPAIGN_DETAILS_PROCESSING = 'AMBASSADORS_SET_CAMPAIGN_DETAILS_PROCESSING'

export function getAmbassadorPayouts (payload) {
  return { type: AMBASSADORS_GET_PAYOUT, payload }
}

export function getAmbassadorDetails (payload) {
  return { type: AMBASSADORS_GET_DETAILS, payload }
}

export function getAmbassadorCampaigns (payload) {
  return { type: AMBASSADORS_GET_CAMPAIGNS, payload }
}

export function getAmbassadorUpcomingCampaigns (payload) {
  return { type: AMBASSADORS_GET_UPCOMING_CAMPAIGNS, payload }
}

export function getAmbassadorSignUps (payload) {
  return { type: AMBASSADORS_GET_SIGNUPS, payload }
}

export function getAmbassadorCampaignDetails (payload) {
  return { type: AMBASSADORS_GET_CAMPAIGN_DETAILS, payload }
}
